import React from 'react'

import styled from '@emotion/styled'

import { ArcadeDivider, Spacer } from '@cash-design-system/react'
import { BetweenSectionVariant } from '@cash-web/protos/squareup/cash/ui/arcade/elements/BetweenSection.pb'
import { FormBlockerElementFixedSpacerElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import logger from '@cash-web/shared/util-logger'

export type FixedSpacerElementProps = FormBlockerElementFixedSpacerElement

const PositionRelative = styled.div`
  position: relative;
`

const ArcadeDividerPositionAbsolute = styled(ArcadeDivider)`
  position: absolute;
  width: 100%;
`

/**
 * A fixed amount of vertical space matching the Arcade spacers:
 * https://www.figma.com/design/o5liMDuHziAIxMMZhqKsqV/01-Arcade---Tokens?node-id=25779-3141&m=dev
 */
export function FixedSpacerElement({
  within_section,
  between_section,
  custom,
}: FixedSpacerElementProps): React.ReactElement | null {
  // TODO: Implement custom spacing support
  if (custom !== undefined) {
    logger.error(new Error('FixedSpacerElement: custom spacing not yet implemented'))
    return null
  }

  // TODO: Implement within_section spacing support
  if (within_section) {
    logger.error(new Error('FixedSpacerElement: within_section spacing not yet implemented'))
    return null
  }

  if (between_section) {
    // X_LARGE_BELOW_CELL: Divider with uneven margins (more space above, less below)
    if (between_section.variant === BetweenSectionVariant.X_LARGE_BELOW_CELL) {
      return (
        <div data-testid="fixed-spacer">
          <Spacer size="m" />
          <PositionRelative>
            <ArcadeDividerPositionAbsolute />
            <Spacer size="xl" />
          </PositionRelative>
        </div>
      )
    }

    // TODO: Implement other between_section variants (LARGE, X_LARGE)
    logger.error(
      new Error(`FixedSpacerElement: between_section variant "${between_section.variant}" not yet implemented`)
    )
    return null
  }

  logger.error(new Error('FixedSpacerElement: no spacing type specified'))
  return null
}
